import type { Snapshot } from "@app/protocol";
import type { ReactNode } from "react";
import type { toastFor } from "../routes/tableToast";
import type { AnyView } from "../variants/types";
import { AutoBanner } from "./AutoBanner";
import { MatchEnd } from "./MatchEnd";
import { Reconnecting } from "./Overlays";
import { Toast } from "./Toast";

/** Whether the table is playing your seat for you (decision 173). */
export function isAuto(seats: Snapshot["table"]["seats"], seat: number | null): boolean {
  return seat === null ? false : (seats[seat]?.auto ?? false);
}

/** Over the whole viewport, letterbox included: the veil must not stop at the canvas edge. */
export function Overlay({
  finished,
  seated,
  view,
  seats,
  target,
  dialog,
}: {
  finished: boolean;
  seated: boolean;
  view: AnyView;
  seats: Snapshot["table"]["seats"];
  target: string | null;
  dialog: ReactNode;
}) {
  return (
    <>
      {finished ? <MatchEnd view={view} seats={seats} target={target} /> : null}
      {dialog}
      <Reconnecting seated={seated} />
    </>
  );
}

/** The band under the table: the seat being played for you, or what just happened. */
export function Band({
  auto,
  dense,
  toast,
}: {
  auto: boolean;
  dense: boolean;
  toast: ReturnType<typeof toastFor>;
}) {
  return auto ? <AutoBanner dense={dense} /> : <Toast toast={toast} dense={dense} />;
}
